<template>
    <input type="password" v-model="model" v-bind="$attrs" v-on="inputListeners" />
</template>

<script>
import BaseInputComponent from '@/helpers/BaseInputComponent'

export default {
    name: 'oc-password-input',
    extends: BaseInputComponent,
    props: {
        value: [String, Number] // this is needed in order v-model to work
    }
}
</script>
